export const manifestLocales = {
  submitPageComment: {
    previewImageAlt: {
      en: 'Submit Page Comment',
      he: 'הערה'
    }
  }
};
